import React from 'react';

const ImageJs = (props) => (
    <svg {...props} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-280 -476)">
                <g transform="translate(120 189)">
                    <g transform="translate(54 180)">
                        <g transform="translate(106 107)">
                            <circle className="background-circle" stroke="#CCC" fillOpacity="0" fill="#000" cx="28"
                                cy="28" r="27.5"/>
                            <path d="M25.7926579,29.3288289 L19.2456336,34.7825164 L36.7543794,34.7825164 L30.2073605,29.3288335 L28.7481697,30.4856112 C28.3127315,30.8334503 27.6875523,30.8334503 27.2524118,30.4858481 L25.7926579,29.3288289 Z M38.7333344,22.542166 L32.0770356,27.8370883 L38.7333344,33.3868069 L38.7333344,22.542166 Z M17.2666786,22.5421609 L17.2666786,33.3868122 L23.9232445,27.8370883 L17.2666786,22.5421609 Z M19.3658943,21.2188732 L28.0000074,28.0878345 L36.6343827,21.2188732 L19.3658943,21.2188732 Z M15.9634681,18.9018828 L15.9683265,18.9015177 C16.0082608,18.8994941 16.0484725,18.8994941 16.0833458,18.9013896 L39.9166672,18.9013896 C40.5696588,18.9013896 41.1,19.4196923 41.1,20.0601314 L41.1,35.9412582 C41.1,36.5816026 40.5697661,37.0997111 39.9166672,37.1 L16.0833015,37.1 C15.4302469,37.0997111 14.900013,36.5816026 14.900013,35.9412582 L14.9000142,20.0606281 C14.8970473,19.4633236 15.3576716,18.962272 15.9634681,18.9018828 Z"
                                stroke="#999" strokeWidth="0.2" fill="#999"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ImageJs;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/assets/Email.js